const Home = () => {
  return (
    <div className="home">
      <h2>Welcome to our page</h2>
      <p>
        We&apos;re glad you&apos;re here. We hope you find our calculator and
        random quote display helpful and enjoyable.
        <br />
        Our calculator is a powerful tool that can help you with a variety of
        tasks, from simple math problems to complex financial calculations. Our
        random quote display is a great way to get inspired or simply learn
        something new.
        <br />
        We hope you&apos;ll take some time to explore our website and find the
        features that are most useful to you. We&apos;re always adding new
        content, so be sure to check back often.
      </p>
      <p>
        We know that life can be busy, so we created this website to make it
        easy for you to get the information and inspiration you need, quickly
        and easily. Our calculator is perfect for those quick math problems that
        you don&apos;t have time to do in your head, and our random quote
        display is a great way to start your day with a smile.
        <br />
        We hope you&apos;ll find our website to be a helpful and enjoyable
        resource. Please feel free to contact us if you have any questions or
        suggestions.
        <br />
        Thank you for visiting!
      </p>
    </div>
  );
};
export default Home;
